import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { CircularProgress } from "@mui/material";
import { fabric } from "fabric";
import PsdCanvas from "../../api/Editercomponents/PsdCanvas";
import { InfoField } from "./FormFields/InfoField";
import { TextFieldWithCounter } from "./FormFields/TextFieldWithCounter";
import { ThumbnailManager } from "./ThumbnailManager";
import { getStepperStyles } from "./styles/stepperStyles";

export const Step1 = ({
  setCanvas,
  canvas,
  handleChange,
  stepperFormdata,
  fieldErrors,
  setStepperFormdata,
  nextStep,
}) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = getStepperStyles();
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  useEffect(() => {
    const newCanvas = new fabric.Canvas("canvas", {
      width: 270,
      height: 420,
    });
    setCanvas(newCanvas);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (stepperFormdata?.file) {
      setLoading(false);
    }
  }, [stepperFormdata?.file]);

  const getPreviewImage = () => {
    if (stepperFormdata?.file) {
      return typeof stepperFormdata?.file === "object"
        ? URL.createObjectURL(stepperFormdata?.file)
        : stepperFormdata?.file;
    }
    return null;
  };

  const previewImage = getPreviewImage();

  return (
    <>
      <div className="">
        <div className="row">
          <div
            className="col-lg-6 mb-3 mb-lg-0"
            style={{ fontFamily: "Helvetica" }}
          >
            {/* <InfoField
              tooltipImage="../assets/images/title.png"
              tooltipAlt="Title help"
            > */}
              <TextFieldWithCounter
                value={stepperFormdata?.title}
                onChange={(e) => handleChange("title", e.target.value)}
                placeholder="Title"
                maxLength={25}
                fieldError={fieldErrors?.title}
                id="title"
                  tooltipImage="../assets/images/title.png"
              tooltipAlt="Title help"
              />
            {/* </InfoField> */}

            <div className="mb-3" style={{ display: "flex", alignItems: "flex-start" }}>
              <div style={{ width: "14px", margin: "4px 8px 0 0" }}></div>
              <div style={{ width: "calc(100% - 22px)", flexGrow: 1 }}>
                <div
                  className={`${
                    fieldErrors?.file ? "upload-area is-invalid" : ""
                  } text-center`}
                >
                  <PsdCanvas
                    handleChange={handleChange}
                    setLoading={setLoading}
                    loading={loading}
                    stepperFormdata={stepperFormdata}
                    fieldErrors={fieldErrors}
                  />
                </div>
                {fieldErrors?.Shadows && (
                  <p className="text-danger text-start">{fieldErrors?.Shadows}</p>
                )}
                {fieldErrors?.Background && (
                  <p className="text-danger text-start">{fieldErrors?.Background}</p>
                )}
                {fieldErrors?.Design && (
                  <p className="text-danger text-start">{fieldErrors?.Design}</p>
                )}
                {fieldErrors?.Highlights && (
                  <p className="text-danger text-start">{fieldErrors?.Highlights}</p>
                )}
                {fieldErrors?.canvasWidth && (
                  <p className="text-danger text-start">{fieldErrors?.canvasWidth}</p>
                )}
                {fieldErrors?.canvasHeight && (
                  <p className="text-danger text-start">{fieldErrors?.canvasHeight}</p>
                )}
                {fieldErrors?.["Background Mask"] && (
                  <p className="text-danger text-start">
                    {fieldErrors["Background Mask"]}
                  </p>
                )}
              </div>
            </div>

            {/* <InfoField */}
              {/* tooltipImage="../assets/images/short-description.png"
              tooltipAlt="Short description help"
            > */}
              <TextFieldWithCounter
                value={stepperFormdata?.short_description}
                onChange={(e) =>
                  handleChange("short_description", e.target.value)
                }
                placeholder="Short Description"
                maxLength={60}
                rows={3}
                fieldError={fieldErrors?.short_description}
                id="description"
                        tooltipImage="../assets/images/short-description.png"
              tooltipAlt="Short description help"
              />
            {/* </InfoField> */}

            {/* <InfoField
              tooltipImage="../assets/images/long-description.png"
              tooltipAlt="Long description help"
            > */}
              <TextFieldWithCounter
                value={stepperFormdata?.long_description}
                onChange={(e) =>
                  handleChange("long_description", e.target.value)
                }
                placeholder="Long Description"
                maxLength={200}
                rows={5}
                fieldError={fieldErrors?.long_description}
                id="description"
                   tooltipImage="../assets/images/long-description.png"
              tooltipAlt="Long description help"
              />
            {/* </InfoField> */}

            {/* <InfoField
              tooltipImage="../assets/images/thumbnails.png"
              tooltipAlt="Thumbnails help"
            > */}
              <ThumbnailManager
                thumbnails={stepperFormdata?.thumbnails}
                setStepperFormdata={setStepperFormdata}
                fieldErrors={fieldErrors}
                tooltipImage="../assets/images/thumbnails.png"
              tooltipAlt="Thumbnails help"
              />
            {/* </InfoField> */}
          </div>

          <div className="col-lg-6">
            <p className="text-center" style={{ fontSize: "18px" }}>
              Welcome to our mockup creator.
              <br />
              Upload your file, and fill basic info about your mockup.
            </p>
            <div
              className="shadow bg-white rounded-4 m-2"
              style={{
                borderStyle: "dashed",
                borderColor: "#000",
                borderWidth: "2px",
                aspectRatio: "1.23",
                width: "100%",
                fontFamily: "Helvetica",
                overflow: "hidden",
              }}
            >
              {loading && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <CircularProgress size={60} />
                </div>
              )}

              {previewImage && (
                <img
                  src={previewImage}
                  alt=""
                  style={{
                    objectFit: "contain",
                    height: "500px",
                    width: "100%",
                    overflow: "hidden",
                  }}
                />
              )}
            </div>
            <div className="mx-4 fs-6 mb-2">
              <label
                className="d-flex align-items-center fs-6 gap-2"
                style={{ cursor: "pointer", fontSize: "14px" }}
              >
                <input
                  type="checkbox"
                  disabled={stepperFormdata?.thumbnails?.length === 0}
                  checked={stepperFormdata?.use_main_file_as_thumbnail || false}
                  onChange={(e) => {
                    stepperFormdata?.thumbnails?.length === 0
                      ? true
                      : handleChange(
                          "use_main_file_as_thumbnail",
                          e.target.checked
                        );
                  }}
                  style={{
                    cursor: "pointer",
                    accentColor: "#c93312",
                  }}
                />
                Use this preview as main thumbnail
              </label>
            </div>
            <p className="mx-4 fs-6 mb-2">
              <a
                href="/blog/mockup-guide"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-underline"
              >
                Read our guide
              </a>{" "}
              on how to prepare your mockup to work with our website
            </p>
            <div className="d-flex justify-content-end gap-3 px-4">
              <Button
                onClick={() => nextStep()}
                disabled={loading}
                style={{
                  backgroundColor: loading ? "#ccc" : "rgb(50,120,228)",
                  color: "white",
                  padding: "12px 26px",
                  fontSize: "15px",
                  width: "170px",
                  border: "none",
                  cursor: loading ? "not-allowed" : "pointer",
                  opacity: loading ? 0.6 : 1,
                }}
                className="red-btn"
              >
                {loading ? "Uploading..." : "Next"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

